import React from 'react';
import classNames from 'classnames';
import { StateValue } from 'xstate';

type ScoreTableProps = {
  names: Array<string>,
  scores: Array<number>,
  currentPlayer: number,
  turnState: StateValue,
  onlinePlayer: string | undefined
}
const ScoreTable = ({ names, scores, currentPlayer, turnState, onlinePlayer}: ScoreTableProps) => {

  const isThisClientsOnlinePlayer = (id: number) => (names[id] === onlinePlayer)

  const isPlayersTurn = (id: number) => (id === currentPlayer)

  const getIndicatorText = (id:number):string => {
    if (isThisClientsOnlinePlayer(id)) {
      if (isPlayersTurn(id)) return 'Your turn'
      else return 'You'
    } else {
      if (isPlayersTurn(id)) return stateToString(turnState)
      else return 'Waiting'
    }
  }

  const stateToString = (state: StateValue):string => {
    if (state === 'start') return 'Starting turn'
    else if (state === 'rolling') return 'Rolling'
    else if (state === 'observing') return 'Thinking'
    else if (state === 'farkle') return 'Farkled'
    else return 'Waiting'
  }

  return (
      <section className="score-table">
        {scores.map((score, id) => (
          <div 
            key={id}
            className={classNames("player-column", { current: isPlayersTurn(id) }, { player: isThisClientsOnlinePlayer(id)})}>
            <h1 className="name">{names[id] || `Player ${id + 1}` }</h1>
            <span className="indicator">{getIndicatorText(id)}</span>
            <h2 className="score">{score}</h2>
          </div>
        ))}
      </section>
    );
}


export default ScoreTable;
